import {
	faMemoPad,
	faCardsBlank,
	faFlaskVial,
	faPenSlash,
	faCog,
} from "@fortawesome/pro-solid-svg-icons";
import type { NavLink } from "./types.d";

export const NAV_LINKS: NavLink[] = [
	{
		href: "/notes",
		icon: faMemoPad,
		text: "Notes",
	},
	{
		href: "/gists",
		icon: faPenSlash,
		text: "Gists",
	},
	{
		href: "/flashcards",
		text: "Flashcards",
		icon: faCardsBlank,
	},
	{
		href: "/quizzes",
		text: "Quizzes",
		icon: faFlaskVial,
	},
	{
		href: "/settings/profile",
		text: "Settings",
		icon: faCog,
	},
];
